import { DateTime } from 'luxon';
import i18n from '../i18n';
import { TEMPLATE_STATUS, Template, TemplateStatus } from '../types/template';

export const getTagText = (status: TemplateStatus | undefined) => {
  switch (status) {
    case TEMPLATE_STATUS.effective:
      return i18n.t('common.status.effective');
    case TEMPLATE_STATUS.archived:
      return i18n.t('common.status.archived');
    case TEMPLATE_STATUS.draft:
      return i18n.t('common.status.draft');
    case TEMPLATE_STATUS.superseded:
      return i18n.t('common.status.superseded');
    default:
      return '';
  }
};

export const getTagColor = (key: TemplateStatus | undefined) => {
  switch (key) {
    case TEMPLATE_STATUS.effective:
      return 'green';
    case TEMPLATE_STATUS.archived:
    case TEMPLATE_STATUS.superseded:
      return 'red';
    case TEMPLATE_STATUS.draft:
      return 'gray';
    default:
      return 'default';
  }
};

export const getDateTimeStr = (dateTime: Date | undefined) => {
  return dateTime ? DateTime.fromJSDate(dateTime).setLocale(i18n.language).toFormat('d MMM yyyy') || '' : '';
};

export const getOwnerText = (template: Pick<Template, 'owner_full_name' | 'owner'>) => {
  return template.owner_full_name || template.owner?.full_name || '-';
};

export const trimAndReplaceMultiSpaceWithOneSpace = (input: string) => {
  return input.trim().replace(/\s\s+/g, ' ');
};

export const convertToNullableNumber = (stringNumber: string | null): number | null => {
  if (stringNumber === '' || stringNumber == null) {
    return null;
  }
  return Number(stringNumber);
};

export const getPeriodicReviewDisplayString = (periodicReview: number | null, newFormat = false) => {
  if (periodicReview === null || (newFormat && periodicReview === 0)) {
    return '-';
  }
  if (periodicReview < 2) {
    return `${periodicReview} ${i18n.t('common.time.month')}`;
  }
  return `${periodicReview} ${i18n.t('common.time.months')}`;
};

export const getReviewApprovalLimitDisplayString = (limit: number | null, newFormat = false) => {
  if (limit === null || (newFormat && limit === 0)) {
    return '-';
  }
  if (limit < 2) {
    return `${limit} ${i18n.t('common.time.day')}`;
  }
  return `${limit} ${i18n.t('common.time.days')}`;
};
